import React, { Component } from "react";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import { Div, Text } from "atomize";
import ImageLink from "../common/ImageLink";

export default class CampaignBranded extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div className="solutions" d="flex" m={{ t: "10.5rem" }} flexDir={{xs: "column-reverse", md: "row"}}>
            <Div d="flex" flexDir="column" justify="center" flexGrow="1">
              <Text
                p={{ r: {xs: "0", lg: "5rem"} }}
                m={{ b: ".7rem" }}
                textSize="title2"
                textWeight="700"
                tag="h2"
              >
                {content.heading}
              </Text>
              <Div p={{ r: {xs: "0", md: "3rem", lg: "6rem"} }}>
                <Text
                  m={{ b: "1.8rem" }}
                  textSize={{xs: "15px", md: "paragraph"}}
                  textColor="#D9D9D9"
                  className="sub-text"
                >
                  {content.text1}
                </Text>
                <Text textSize="paragraph" textColor="gray450">
                  {content.text2}
                </Text>
              </Div>
            </Div>
            <Div flexGrow="1" m={{b: {xs: "10rem", md: "0"} }}>
              <ImageLink link=""><Div
                bgImg={content.img}
                bgSize="cover"
                bgPos="center"
                p={{ b: "98.7%" }}
                pos="relative"
              >
                <Div
                  maxW={{xs: "100%", md: "22.8rem"}}
                  bottom={{xs: "-40%", md: "-3.375rem"}}
                  left={{xs: "0", md: "-2.4rem"}}
                  bg="gradient2"
                  pos="absolute"
                  p={{xs: "1.25rem", md: "1.5rem"}}
                >
                  <Text textColor="black" textSize={{xs: "subheader5", md: "14px"}} style={{lineHeight: "24px"}} textWeight="bold">
                    “{content.imgText}”
                  </Text>
                </Div>
              </Div></ImageLink>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
